import React, {Component} from 'react'
import PropTypes from 'prop-types'
import showDateTime from "../../../shared/ShowDateTime"

class HistoryRow extends Component {
    render() {
        const {history, index} = this.props
        const {created_at, description, meta, IP, action} = history
        const {printer, cutter, actor} = meta

        return (
            <tr className="HistoryRow">
                <td className="colID">{index + 1}</td>
                <td className="colTime">{showDateTime(created_at)}</td>
                <td className="colDescription">
                    {description || '-'}

                    {
                        meta.hasOwnProperty('sub_id') &&
                        <span> tới lô con <a rel="noopener noreferrer" target='_blank'
                                             href={`/batches/${meta.sub_id}`}>{meta.sub_name}</a>
                        </span>
                    }
                </td>
                <td className='colActor'>{actor || '-'}</td>
                <td className="colPrinterName">{printer || '-'}</td>
                <td className="colPresserrName">{cutter || '-'}</td>
                <td className="colIP">{IP || '-'}</td>
                <td className="colKey"><code>{action || '-'}</code></td>
            </tr>
        )
    }
}

HistoryRow.propTypes = {
    history: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
}

export default HistoryRow